"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeType = exports.toggleTheme = void 0;
var ThemeType;
(function (ThemeType) {
    ThemeType[ThemeType["Dark"] = 0] = "Dark";
    ThemeType[ThemeType["Light"] = 1] = "Light";
})(ThemeType || (ThemeType = {}));
exports.ThemeType = ThemeType;
var toggleTheme = function (theme) {
    if (theme === ThemeType.Light) {
        document.documentElement.classList.add('honeywell-light-theme');
        document.documentElement.classList.remove('honeywell-dark-theme');
    }
    if (theme === ThemeType.Dark) {
        document.documentElement.classList.remove('honeywell-light-theme');
        document.documentElement.classList.add('honeywell-dark-theme');
    }
};
exports.toggleTheme = toggleTheme;
